import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

const getDefaultSelectedConnectingTrain = () => {
  return {
    fromScheduleId: null,
    toScheduleId: null,
    transferStationId: null,
    startDate: null,
    endDate: null,
  };
};

export default {
  state: () => ({
    selectedConnectingTrain: getDefaultSelectedConnectingTrain(),
  }),

  mutations: {
    setSelectedConnectingTrain(state, connectingTrain) {
      Vue.set(state, "selectedConnectingTrain", connectingTrain);
    },
    setDefaultSelectedConnectingTrain(state) {
      Vue.set(state, "selectedConnectingTrain", getDefaultSelectedConnectingTrain());
    },
  },

  actions: {
    //TODO: load, update, create
    createConnectingTrain: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/connection-schedule/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadConnectingTrains: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/entity").then((response) => {
        context.commit("setSelectedConnectingTrain", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadConnectingTrain: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedConnectingTrains: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSchedulePairs: (context, request) => {
      return axios.get(context.getters.getTmsServiceUrl + "/schedules/schedule-pairs").then((response) => {
        return response.data;
      });
    },

    loadSelectedConnectingTrainHistory: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/history/" + connectingTrain.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteConnectingTrain: (context, connectingTrain) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/connection-schedule/entity/" + connectingTrain.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          connectingTrain.intents = intents;
          connectingTrain.intentId = response.data.id;
          return connectingTrain;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftConnectingTrain: (context, connectingTrain) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/connection-schedule/draft/" + connectingTrain.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishConnectingTrain: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/publish/" + connectingTrain.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (connectingTrain.intents[0].type === "DELETE_TRAIN_CONNECTING") {
          let connectingTrains = context.getters.getSegments;
          connectingTrains.splice(connectingTrains.indexOf(connectingTrain), 1);
          context.commit("setConnectingTrains", connectingTrains);
        }
        return response.data;
      });
    },

    rejectConnectingTrain: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/reject/" + connectingTrain.intentId).then((response) => {
        helper.recallOrRejectEntity(connectingTrain, "connectingTrain");
        return response.data;
      });
    },

    sendToApprovalConnectingTrains: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/sendToApproval/" + connectingTrain.intentId).then((response) => {
        if (connectingTrain.intents[0].type === "CREATE_TRAIN_CONNECTING") {
          connectingTrain.intents[0].status = "WAITING_APPROVAL";
        } else if (connectingTrain.intents[0].type === "UPDATE_TRAIN_CONNECTING") {
          connectingTrain.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallConnectingTrain: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/recall/" + connectingTrain.intentId).then((response) => {
        helper.recallOrRejectEntity(connectingTrain, "connectingTrain");
        return response.data;
      });
    },
    cancelConnectingTrain: (context, connectingTrain) => {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/cancel/" + connectingTrain.intentId).then((response) => {
        return response.data;
      });
    },
    loadConnectingScheduleCountByScheduleId(context, { scheduleId }) {
      return axios.get(context.getters.getMcServiceUrl + "/connection-schedule/count-by-schedule-id/" + scheduleId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedConnectingTrain: (state) => {
      return state.selectedConnectingTrain;
    },
  },
};
